import React from "react";
import { Button } from "@chakra-ui/react";
import { FilterIcon } from "icons";

const FilterButton = ({
  onClick,
  hasSelectedFilters,
}: {
  onClick: () => void;
  hasSelectedFilters: boolean;
}) => (
  <>
    <Button
      size="md"
      onClick={onClick}
      rightIcon={<FilterIcon color="inherit" />}
      colorScheme="grey"
      variant={hasSelectedFilters ? "primary" : "outline"}
      borderWidth="1px"
      borderRadius="12px"
      borderColor={"gray.500"}
      bg={hasSelectedFilters ? "gray.500" : "unset"}
      _hover={{
        bg: hasSelectedFilters ? "gray.600" : "gray.50",
        borderColor: hasSelectedFilters ? "gray.600" : "gray.500",
      }}
    >
      Filter
    </Button>
  </>
);

export default FilterButton;
